<template>
  <a-layout class="profile">
    <div class="profile-component">
      <!-- USER PROFILE WITH IDENTITY VERIFICATION LINK -->
      <div v-if="loggedUser" class="user-profile">
        <!-- USER PROFILE -->
        <a-badge
          status="success"
          :title="labels.verifyIdentity.verified"
          v-if="isVerified"
        >
          <a-icon
            :title="labels.verifyIdentity.verified"
            slot="count"
            type="check-circle"
            v-if="loggedUser.ivp"
          />
          <a-avatar
            size="large"
            icon="user"
            class="user-avatar"
            v-bind="loggedUser.avatar ? { src: loggedUser.avatar } : {}"
          />
        </a-badge>
        <a-avatar
          v-else
          size="large"
          icon="user"
          class="user-avatar"
          v-bind="loggedUser.avatar ? { src: loggedUser.avatar } : {}"
        />
        <h2>{{ loggedUser.firstname }} {{ loggedUser.lastname }}</h2>
        <p>{{ loggedUser.email }}</p>
        <!-- MENU -->
        <a-button
          v-if="loggedUser && ((!isVerified && !isRequested) || isRejected)"
          class="identity-verification"
          type="link"
          @click="goToVerifyIdentity"
          block
        >
          {{ labels.verifyIdentity.verifyButton }}
        </a-button>
        <div
          v-else-if="loggedUser && !isVerified && isRequested && isPending"
          class="identity-verification-pending"
        >
          <a-badge
            status="processing"
            :title="labels.verifyIdentity.underReview"
          >
            <span class="badge-processing" slot="count">{{
              labels.verifyIdentity.underReview
            }}</span>
            <span>{{ labels.verifyIdentity.identityVerification }}</span>
          </a-badge>
        </div>
      </div>

      <div v-if="currentScreen === 'menu'">
        <a-list
          class="profile-list"
          size="small"
          bordered
          :data-source="options"
        >
          <a-list-item
            slot="renderItem"
            slot-scope="item"
            @click="goToEdit(item.id, item.link)"
          >
            <div>
              {{ item.title }}
            </div>
            <a-button type="default" class="link-action">
              <a-icon type="right" />
            </a-button>
          </a-list-item>
          <div slot="header">
            <h2>Ajustes</h2>
          </div>
        </a-list>
      </div>
    </div>
  </a-layout>
</template>
<script>
import loadingMixin from "@/mixins/loadingMixin";
import labels from "@/utils/labels";
import { mapGetters, mapActions } from "vuex";

export default {
  components: {},
  name: "Profile",
  mixins: [loadingMixin],
  data() {
    return {
      labels: {
        ...labels.profile,
        appName: labels.appName,
      },
      options: [
        { id: 1, title: "Cuenta Bancaria", link: "bankaccount" },
        { id: 2, title: "Verificación de Teléfono", link: "verifyphone" },
        { id: 3, title: "Cambiar Contraseña", link: "changepassword" },
      ],
      currentScreen: "menu",
      currentOption: null,
      loading: false,
    };
  },
  computed: {
    ...mapGetters({
      loggedUser: "clientAuth/getLoggedUser",
      verificationState: "identityVerification/getVerificationState",
    }),
    isRejected() {
      return (
        this.verificationState && this.verificationState.status === "rejected"
      );
    },
    isVerified() {
      return (
        this.loggedUser && this.loggedUser.ivp && this.loggedUser.ivp.verified
      );
    },
    isRequested() {
      return this.loggedUser.ivp && this.loggedUser.ivp?.requested;
    },
    isPending() {
      return this.verificationState?.status === "pending";
    },
  },
  methods: {
    ...mapActions({
      getIdentityVerifyState: "identityVerification/identityVerifyState",
    }),
    goToEdit(_id, link) {
      this.$router.push({ name: link });
    },
    goToVerifyIdentity() {
      if (
        !this.loggedUser ||
        this.$router.currentRoute.name === "verify-identity"
      ) {
        return;
      }
      this.$router.push({ name: "verify-identity" });
    },
    async getVerificationState() {
      try {
        this.loading = true;
        await this.getIdentityVerifyState();
      } catch (error) {
        console.error("Error fetching identity verification state:", error);
      } finally {
        this.loading = false;
      }
    },
  },
  watch: {
    loggedUser: {
      deep: true,
      immediate: true,
      handler() {
        if (!this.isVerified && this.isRequested) {
          this.getVerificationState();
        }
      },
    },
  },
};
</script>
<style lang="scss" scoped>
@import "~@/assets/scss/variable";

.profile {
  max-width: 100% !important;
  font-family: "Roboto", sans-serif;
  background-color: transparent;
  &-list {
    background-color: var(--card-bg);
  }
  .profile-component {
    padding: 10px;
    color: var(--white);

    .go-back {
      background: transparent !important;
      color: var(--btn-bg-primary);
      border-color: var(--btn-bg-primary);
      margin-bottom: 10px;
    }

    .ant-list {
      ::v-deep .ant-list-header {
        h2 {
          color: var(--white);
          text-align: center;
          padding: 0;
          margin-bottom: 0;
        }
      }

      ::v-deep .ant-list-items {
        .ant-list-item {
          margin-bottom: 1px;
          color: var(--white) !important;
          cursor: pointer;

          .link-action {
            background: transparent;
            border: none;
            color: var(--white);
          }
        }
      }
    }

    .user-profile {
      text-align: center;
      margin-bottom: 20px;
      background-color: var(--card-shop-bg);
      padding: 20px;
      border-radius: 8px;
      .ant-badge {
        .anticon {
          top: 86px;
          right: 5px;
        }
      }
      .user-avatar {
        width: 100px;
        height: 100px;
        &.ant-avatar-icon {
          font-size: 70px;
          line-height: 1.3;
        }
      }

      .identity-verification {
        margin-top: 10px;
        font-weight: bold;
        font-size: 16px;
        color: var(--btn-bg-primary) !important;
        &-pending {
          display: flex;
          justify-content: center;
          align-items: center;
          span {
            color: var(--btn-bg-primary);
            margin-top: 10px;
            font-weight: bold;
            font-size: 20px;
          }
          .badge-processing {
            background-color: var(--btn-bg-primary);
            color: var(--btn-text-primary);
            padding: 2px 8px;
            border-radius: 12px;
            font-size: 12px;
            top: -15px !important;
            right: 3px !important;
          }
        }
      }

      .identity-verified {
        margin-top: 10px;
        font-weight: bold;
        font-size: 16px;
        display: flex;
        justify-content: center;
        align-items: center;
      }

      h2 {
        font-size: 26px;
        margin-top: 10px;
        margin-bottom: 0;
        color: var(--text);
      }
      p {
        margin: 0;
        font-size: 16px;
        color: var(--text);
      }
    }
  }
}

.light {
  .profile {
    .profile-component {
      color: var(--primary);

      .go-back {
        background: transparent !important;
        color: var(--btn-bg-primary);
        border-color: var(--btn-bg-primary);
      }

      .ant-list {
        ::v-deep .ant-list-header {
          h2 {
            color: var(--primary);
          }
        }

        ::v-deep .ant-list-items {
          .ant-list-item {
            color: var(--primary) !important;

            .link-action {
              background: transparent;
              border: none;
              color: var(--primary);
            }
          }
        }
      }
    }
  }
}
</style>
